module.exports = "https://static.energy5.com/_next/static/images/linkedin-db78f9d1ebcf3bc3ecbdc3577ae487d8.png";